import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class ResponseTypeService {
  constructor(private http: HttpClient) {}

  public get(params: any) {
    let projectId;
    let routeId;

    [params, projectId, routeId] = splayParams(params, "projectId", "routeId");
    const url = `/api/v5/projects/${projectId}/routes/${routeId}/response-types`;

    return this.http.get(url, { params });
  }
}
